import { Delete, Edit } from "@material-ui/icons";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { Button, FloatingLabel, Form } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import {
    useAddVehicleInventoryDataMutation, useDeleteVehicleInventorydataMutation, useGetAdditionalFieldsForVehicleQuery,
    useGetVehicleInventoryListQuery,
    useGetVehicleTypeListQuery,
    useLazyGetVehicleInventoryByInventoryIdQuery,
    useUpdateVehicleInventoryListMutation
} from '../../../features/vehicle/GetVehicleFieldSlice';
import '../../../style.css';
import { useCustomData } from '../../Sidebar/Permission';
import Spinner from '../../Spinner';
import errorHandler from "../../hooks/ErrorHanlder";
import VehicleWrapper from "./VehicleWrapper";


const ManageInventory = () => {
    const [permission] = useCustomData()
    const [fieldsValue, setFieldsValue] = useState()
    const [deleteId, setDeleteId] = useState()
    const [open, setOpen] = useState(false);
    const [vehicleId, setVehicleId] = useState()
    const [disable, setDisable] = useState(false)
    const [clear, setClear] = useState(false)
    const [vehicleType, setVehicleType] = useState()
    const [inventoryData, setInventoryData] = useState({})
    const [fieldDetails, setFieldDetails] = useState()
    const [fieldArray, setFieldArray] = useState({});
    const [isShow, setIsShow] = useState(false)
    const { data: vehicleList, refetch: vehicleListRefetch, isLoading: vehicleListIsLoading } = useGetVehicleTypeListQuery({ refetchOnMountOrArgChange: true });
    const { data: getAdditionalFieldsForVehicle } = useGetAdditionalFieldsForVehicleQuery((fieldsValue), { refetchOnMountOrArgChange: false, skip: fieldsValue == null || fieldsValue == "", });
    const [addVehicleInventoryData] = useAddVehicleInventoryDataMutation();
    const [deleteVehicleInventorydata] = useDeleteVehicleInventorydataMutation()
    const { data: inventoryList, isLoading, refetch } = useGetVehicleInventoryListQuery()
    const [updateVehicleInventoryList] = useUpdateVehicleInventoryListMutation()
    const tableList = inventoryList?.data;
    const [dataInventory, result] = useLazyGetVehicleInventoryByInventoryIdQuery()
    const editInventoryData = result?.data?.data
    const { register, setValue, formState: { errors }, reset, getValues, setError } = useForm({ mode: "onChange" });
    const [dynamicErrors, setDynamicErrors] = useState({});

    useEffect(() => {
        if (!vehicleListIsLoading) {
            setVehicleType(vehicleList?.data)
        }
        vehicleListRefetch()
    }, [vehicleList, vehicleListIsLoading, vehicleListRefetch])

    useEffect(() => {
        let arrayField = [];
        if (getAdditionalFieldsForVehicle?.data?.fieldDetailsDTO?.fieldId !== null)

            getAdditionalFieldsForVehicle?.data?.fieldDetailsDTO?.forEach((d) => {
                if (d?.fieldId === null) {
                    return
                }
                arrayField.push(d)
            })
        setFieldDetails(arrayField)
    }, [getAdditionalFieldsForVehicle])

    useEffect(() => {
        if (!isShow) return
        const obj = {}
        setInventoryData(editInventoryData?.additionalFieldDetail)
        editInventoryData?.additionalFieldDetail?.forEach((d) => {
            obj[d?.fieldName + "_" + d?.fieldId] = d?.fieldValue
        })
        setFieldArray(obj)
        if (editInventoryData?.additionalFieldDetail) {
            setFieldDetails(editInventoryData?.additionalFieldDetail)
        }
        reset({ ...inventoryData, Vehicle_Number: editInventoryData?.vehicleNumber })
        setClear(editInventoryData?.vehicleTypeName)
    }, [editInventoryData?.additionalFieldDetail, editInventoryData?.vehicleNumber, editInventoryData?.vehicleTypeName, inventoryData, reset, result, isShow])

    useEffect(() => {
        setValue("Vehicle_Number", editInventoryData?.vehicleNumber);
    }, [editInventoryData, setValue]);

    const selectHandler = (e) => {
        setFieldsValue(e.target.value)
        const user = vehicleType?.find(u => u.vehicleTypeId == e.target.value);
        setVehicleId(user?.vehicleTypeId)
        setFieldArray({});
        setInventoryData({});
        setClear('');
        setDynamicErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors.VehicleType;
            return newErrors;
        });
    }
    const handleField = (e) => {
        const { name, value } = e.target;
        setFieldArray(prev => ({ ...prev, [name]: value }));
        validateField(name, value);
    }

    const validateField = (name, value) => {
        if (!value || value.trim() === "") {
            setDynamicErrors(prev => ({
                ...prev,
                [name]: `${name.split("_")[0]} is required`
            }));
        } else {
            setDynamicErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    const validateAllDynamicFields = () => {
        const errors = {};
        fieldDetails?.forEach(field => {
            const key = `${field.fieldName}_${field.fieldId}`;
            if (!fieldArray[key] || fieldArray[key].trim() === "") {
                errors[key] = `${field.fieldName} is required`;
            }

        });
        if ((inventoryData?.length == null || inventoryData?.length === 0) && (fieldsValue == null || fieldsValue == "")) {
            errors.VehicleType = "Vehicle Type is required";
        }

        setDynamicErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const onSubmit = async () => {
        if (!validateAllDynamicFields() || errors.Vehicle_Number) {
            if (getValues("Vehicle_Number") === "" || getValues("Vehicle_Number") == null) {
                setError("Vehicle_Number", { type: "manual", message: "Vehicle Number is required" });
            }
            return;
        }
        try {
            let array = []
            for (let key in fieldArray) {
                array.push(
                    {
                        fieldId: Number(key?.split("_")[1]),
                        fieldValue: fieldArray[key],
                        fieldName: key?.split("_")[0],
                    }
                )
            }
            const newData = {
                "vehicleTypeId": vehicleId,
                "vehicleNumber": getValues('Vehicle_Number'),
                "additionalFieldDetail": array
            }
            await addVehicleInventoryData(newData).unwrap()
            toast.success("Vehicle added to inventory succesfully!", {
                position: "top-center",
            })
            reset({ Vehicle_Number: "" });
            setFieldArray({});
            setVehicleId("");
            setFieldDetails("");
            setFieldsValue("");
            setVehicleType([""]);
            const dataTest = await vehicleListRefetch();
            setVehicleType(dataTest?.data?.data);
            refetch();
        }
        catch (error) {
            errorHandler(error)
        }
    }
    const onCancel = () => {
        setInventoryData({});
        setFieldArray({});
        setFieldDetails([]);
        setIsShow(false)
        setDisable(false)
        setClear("")
        setFieldsValue("")
        reset({ Vehicle_Number: "" })
    }
    const updateInventory = async () => {
        if (!validateAllDynamicFields()) {
            return;
        }
        try {
            let array1 = []
            for (let key in fieldArray) {
                array1.push(
                    {
                        fieldId: Number(key?.split("_")[1]),
                        fieldValue: fieldArray[key],
                    }
                )
            }
            const updateData = {
                "vehicleInventoryId": editInventoryData?.vehicleInventoryId,
                "vehicleNumber": getValues("Vehicle_Number"),
                "additionalFieldDetail": array1
            }
            await updateVehicleInventoryList(updateData).unwrap()
            refetch()
            setInventoryData({})
            setFieldsValue("")
            setClear("")
            setFieldDetails("")
            setIsShow(false)
            setVehicleType([""]);
            const dataTest = await vehicleListRefetch();
            setVehicleType(dataTest?.data?.data);
            toast.success("Vehicle Updated to Inventory Succesfully!", { position: "top-center" })
            setDisable(false)
            reset({ Vehicle_Number: "" })
        }
        catch (error) {
            errorHandler(error)
        }

    }

    const handleClose = async () => {
        try {
            setOpen(false);
            await deleteVehicleInventorydata(deleteId).unwrap()
            toast.success("Vehicle removed from inventory successfully!", {
                position: "top-center",
            })
            vehicleListRefetch()
            refetch()
        }
        catch (error) {
            errorHandler(error)
        }
    };

    if (isLoading) return <><Spinner /></>;
    const columns = [
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            width: 140,
            disableClickEventBubbling: true,
            renderCell: (data) => {
                const onClick = (e) => {
                    setInventoryData({});
                    setFieldArray({});
                    setFieldDetails([]);
                    dataInventory(data?.id);
                    setIsShow(true)
                    setDisable(true)
                };
                const onRemove = (data) => {
                    setDeleteId(data?.id)
                    setOpen(true);
                };

                return (
                    <>
                        <>
                            <div className="action_btn">
                                {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Update') !== -1 ?
                                    <span className="edit_btn" onClick={onClick}><Edit /></span> :
                                    <span className="edit_btn disable"><Edit /></span>
                                }
                                {permission.find(event => event.moduleId === 33)?.permissionType?.indexOf('Delete') !== -1 ?
                                    <span className="del_btn" onClick={() => onRemove(data)}><Delete /></span> :
                                    <span className="del_btn disable"><Delete /></span>}
                            </div>
                        </>
                        <>
                            <div>
                                <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                                    <DialogTitle id="alert-dialog-title">
                                        Delete Confirmation
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to delete this row?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button className="btn-secondary" onClick={() => { setOpen(false); }}>Cancel</Button>
                                        <Button className="btn-primary" onClick={() => { handleClose(); }} autoFocus> Confirm</Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        </>
                    </>
                )
            },
        },
        { field: "Vehicle_Type", headerName: "Vehicle Type", width: 200 },
        { field: "Vehicle_Number", headerName: "Vehicle Number", width: 200 },
    ];
    const rows =
        tableList?.map((data) => {
            return {
                id: data?.vehicleInventoryId,
                Vehicle_Type: data?.vehicleTypeName,
                Vehicle_Number: data?.vehicleNumber,
            }
        })

    return (
        <VehicleWrapper
            onCancel={onCancel}
            isEdit={isShow}
            onSubmit={isShow ? updateInventory : onSubmit}
            rows={rows}
            columns={columns}
            listTitle="Manage Inventory"
            label="Inventory descriptions">
            <VehicleWrapper.SectionOne>
                <Form.Group controlId="Vehicletype" style={{ maxWidth: "300px" }}>
                    <FloatingLabel controlId="floatingSelectGrid" label="Select a vehicle type">
                        <Form.Select aria-label="Floating label select example" name="VehicleType" disabled={disable} onChange={selectHandler}
                        >
                            <option value="">{isShow && clear ? clear : "Select "}</option>:
                            <>
                                {
                                    vehicleType?.map((data, index) => (
                                        <option key={index} value={data?.vehicleTypeId}
                                            selected={data?.vehicleTypeId === inventoryData?.vehicleInventoryId}
                                        >
                                            {data?.vehicleTypeDescription}
                                        </option>
                                    ))
                                }
                            </>
                        </Form.Select>
                    </FloatingLabel>
                    {dynamicErrors.VehicleType && <p className="error-message">{dynamicErrors.VehicleType}</p>}
                </Form.Group>
            </VehicleWrapper.SectionOne>
            <div className="dynamic-input d-flex flex-wrap">
                <div className="form-floating mr-2">
                    <Form.Control type="text" autoComplete="off" placeholder="Vehicle Number" name="Vehicle_Number" {...register('Vehicle_Number', { required: 'Field is required', pattern: /^[a-zA-Z0-9]{1,10}$/, message: "special character not allowed" })}
                        disabled={disable} />
                    <label htmlFor="Item">Vehicle Number</label>
                    <p className="error-message">{errors?.Vehicle_Number?.message}</p>
                </div>
                <>
                    {fieldDetails && fieldDetails?.map((data, index) => {
                        const fieldKey = `${data.fieldName}_${data.fieldId}`;

                        return <div className="form-floating mr-2" key={index} >
                            {data.fieldType === "Text" ?
                                <>
                                    <Form.Control type="text" value={fieldArray[data?.fieldName + "_" + data?.fieldId] || inventoryData?.fieldName}
                                        autoComplete="off" placeholder="" name={data?.fieldName + "_" + data?.fieldId}
                                        onChange={handleField} min="0" />
                                    <label htmlFor="Item">{data?.fieldName}</label>
                                    <p className="error-message">{errors.Item?.message}</p>
                                </>
                                : <FloatingLabel controlId="floatingSelectGrid" label={data?.fieldName}>
                                    <Form.Select
                                        aria-label="Floating label select example"
                                        name={`${data.fieldName}_${data.fieldId}`}
                                        value={fieldArray[data?.fieldName + "_" + data?.fieldId] || inventoryData?.fieldName}
                                        onChange={handleField}
                                        style={{ minWidth: "200px" }}
                                    >
                                        <option value="">Select</option>
                                        {["Yes", "No"]?.map((value) => (
                                            <option key={value} value={value}>
                                                {value}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FloatingLabel>
                            }
                            {dynamicErrors[fieldKey] && <p className="error-message">{dynamicErrors[fieldKey]}</p>}
                        </div>
                    })}
                </>
            </div>
        </VehicleWrapper>
    )
}

export default ManageInventory;
